export const noEmptyRule = (name: string) => ({
  required: true,
  message: `${name} can not be empty!`,
});
